import EntityType from '@/shared/enums/EntityType';

/**
 * Returns a parent relationship entity type where needed.
 *
 * @param {Object} item
 *
 * @return {string}
 */
export default function getTooltipEntityType(item) {
  if (item.type === EntityType.PROPERTY_VALUE) {
    return EntityType.PROPERTY;
  }
  if (item.type === EntityType.SKILL_LEVEL) {
    return EntityType.SKILL;
  }
  return item.type;
}
